// extracted by mini-css-extract-plugin
module.exports = {"container":"searchresults-module--container--19gzM","noResults":"searchresults-module--noResults--1Fq0z"};